(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 8312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(5970);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3291:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8958);

/* harmony default export */ __webpack_exports__["Z"] = ({
    getNewsList: ()=>"".concat(_api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].apiEndpoint */ .Z.apiEndpoint, "/api/").concat(_api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].space */ .Z.space, "/database/news/row"),
    getNewDetail: ()=>"".concat(_api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].apiEndpoint */ .Z.apiEndpoint, "/api/").concat(_api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].space */ .Z.space, "/database/news/row")
});


/***/ }),

/***/ 5970:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var effector_react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(4190);
/* harmony import */ var src_state_manager_global__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5789);
/* harmony import */ var src_state_manager_landing__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2088);
/* harmony import */ var src_state_manager_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(149);
/* harmony import */ var src_configs_db_columns_keys__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1872);
/* harmony import */ var src_configs_db_enum_v2_options__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(662);
/* harmony import */ var src_core_hooks_useSettings__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1268);
/* harmony import */ var src_core_components_spinner__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(2503);
/* harmony import */ var src_layouts_default_layout__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(5113);
/* harmony import */ var src_state_manager_news__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(2094);
//** React Imports


// ** Next Imports

//** Effect Imports

// ** Source code Imports









const keyValuesKeys = src_configs_db_columns_keys__WEBPACK_IMPORTED_MODULE_6__/* ["default"].keyValues */ .Z.keyValues;
const keyValuesEnum = src_configs_db_enum_v2_options__WEBPACK_IMPORTED_MODULE_7__/* ["default"].keyValues */ .Z.keyValues;
const howItWorkKeys = src_configs_db_columns_keys__WEBPACK_IMPORTED_MODULE_6__/* ["default"].landing_how_work_it */ .Z.landing_how_work_it;
const howItWorkEnum = src_configs_db_enum_v2_options__WEBPACK_IMPORTED_MODULE_7__/* ["default"].landing_how_work_it */ .Z.landing_how_work_it;
const artistsKeys = src_configs_db_columns_keys__WEBPACK_IMPORTED_MODULE_6__/* ["default"].landing_artists_slider */ .Z.landing_artists_slider;
const artistsEnum = src_configs_db_enum_v2_options__WEBPACK_IMPORTED_MODULE_7__/* ["default"].landing_artists_slider */ .Z.landing_artists_slider;
const controlSlidesKeys = src_configs_db_columns_keys__WEBPACK_IMPORTED_MODULE_6__/* ["default"].controls_slides */ .Z.controls_slides;
const controlSlidesEnum = src_configs_db_enum_v2_options__WEBPACK_IMPORTED_MODULE_7__/* ["default"].controls_slides */ .Z.controls_slides;
const platformSlidesKeys = src_configs_db_columns_keys__WEBPACK_IMPORTED_MODULE_6__/* ["default"].landing_platform_slides */ .Z.landing_platform_slides;
const platformSlidesEnum = src_configs_db_enum_v2_options__WEBPACK_IMPORTED_MODULE_7__/* ["default"].landing_platform_slides */ .Z.landing_platform_slides;
const LandingPage = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(()=>Promise.all(/* import() */[__webpack_require__.e(802), __webpack_require__.e(785), __webpack_require__.e(520), __webpack_require__.e(639)]).then(__webpack_require__.bind(__webpack_require__, 639)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(639)
            ]
    },
    ssr: false
});
const Home = ()=>{
    const { settings  } = (0,src_core_hooks_useSettings__WEBPACK_IMPORTED_MODULE_8__/* .useSettings */ .r)();
    const { language  } = (0,effector_react__WEBPACK_IMPORTED_MODULE_12__/* .useStore */ .oR)(src_state_manager_global__WEBPACK_IMPORTED_MODULE_3__/* ["default"].locale */ .ZP.locale);
    const { preload: preloadVideo  } = (0,effector_react__WEBPACK_IMPORTED_MODULE_12__/* .useStore */ .oR)(src_state_manager_runtime__WEBPACK_IMPORTED_MODULE_5__/* ["default"].video */ .Z.video);
    const { artistsItems , landingDetails , workItItems , platforms , platformSlides , faqItems , controlsSlides , partnersItems  } = (0,effector_react__WEBPACK_IMPORTED_MODULE_12__/* .useStore */ .oR)(src_state_manager_landing__WEBPACK_IMPORTED_MODULE_4__/* ["default"].landing */ .ZP.landing);
    const { data: newsData  } = (0,effector_react__WEBPACK_IMPORTED_MODULE_12__/* .useStore */ .oR)(src_state_manager_news__WEBPACK_IMPORTED_MODULE_11__/* ["default"].news */ .Z.news);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        (0,src_state_manager_landing__WEBPACK_IMPORTED_MODULE_4__/* .getTableForLanding */ .hg)({
            key: "artistsItems",
            tableName: "landing_artists_slider",
            query: {
                $and: [
                    {
                        ["data.".concat(artistsKeys.language)]: language === "ru" ? artistsEnum.language.ru : artistsEnum.language.en
                    }
                ]
            }
        });
        (0,src_state_manager_landing__WEBPACK_IMPORTED_MODULE_4__/* .getTableForLanding */ .hg)({
            key: "partnersItems",
            tableName: "landing_partners_slides"
        });
        (0,src_state_manager_landing__WEBPACK_IMPORTED_MODULE_4__/* .getTableForLanding */ .hg)({
            key: "workItItems",
            tableName: "landing_how_work_it",
            query: {
                $and: [
                    {
                        ["data.".concat(howItWorkKeys.language)]: language === "ru" ? howItWorkEnum.language.ru : howItWorkEnum.language.en
                    }
                ]
            }
        });
        (0,src_state_manager_landing__WEBPACK_IMPORTED_MODULE_4__/* .getTableForLanding */ .hg)({
            key: "platformSlides",
            tableName: "landing_platform_slides",
            query: {
                $and: [
                    {
                        ["data.".concat(platformSlidesKeys.language)]: language === "ru" ? platformSlidesEnum.language.ru : platformSlidesEnum.language.en
                    }
                ]
            }
        });
        (0,src_state_manager_landing__WEBPACK_IMPORTED_MODULE_4__/* .getTableForLanding */ .hg)({
            key: "faqItems",
            tableName: "landing_faq"
        });
        (0,src_state_manager_landing__WEBPACK_IMPORTED_MODULE_4__/* .getTableForLanding */ .hg)({
            key: "controlsSlides",
            tableName: "controls_slides",
            query: {
                $and: [
                    {
                        ["data.".concat(controlSlidesKeys.language)]: language === "ru" ? controlSlidesEnum.language.ru : controlSlidesEnum.language.en
                    }
                ]
            },
            sort: [
                {
                    sort: "asc",
                    column: controlSlidesKeys.order
                }
            ]
        });
        (0,src_state_manager_news__WEBPACK_IMPORTED_MODULE_11__/* .getNewsList */ .I)({
            query: {
                ["data.showToLanding"]: true
            }
        });
        (0,src_state_manager_landing__WEBPACK_IMPORTED_MODULE_4__/* .getLandingDetail */ .d_)({
            query: {
                $or: [
                    {
                        "data.groupName": "landing"
                    },
                    {
                        "data.groupName": "shared"
                    }
                ],
                $and: [
                    {
                        ["data.".concat(keyValuesKeys.language)]: language === "ru" ? keyValuesEnum.language.ru : keyValuesEnum.language.en
                    }
                ]
            }
        });
    }, [
        language
    ]);
    const isLoading = artistsItems.loading || landingDetails.loading || workItItems.loading || platformSlides.loading || faqItems.loading || controlsSlides.loading || newsData.loading || partnersItems.loading || preloadVideo;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            isLoading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_core_components_spinner__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                settings: settings
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_layouts_default_layout__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                sx: {
                    height: isLoading ? 0 : "auto",
                    visibility: isLoading ? "hidden" : "visible"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LandingPage, {
                    loading: isLoading,
                    artists: artistsItems.data,
                    workItItems: workItItems.data,
                    platforms: platforms.data,
                    platformSlides: platformSlides.data,
                    landingDetails: landingDetails.data,
                    faqItems: faqItems.data,
                    controlsSlides: controlsSlides.data,
                    newsData: newsData,
                    partnersSlides: partnersItems.data
                })
            })
        ]
    });
};
Home.getLayout = (page)=>page;
/* harmony default export */ __webpack_exports__["default"] = (Home);


/***/ }),

/***/ 2094:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ getNewsList; }
/* harmony export */ });
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(196);
/* harmony import */ var effector__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8116);
/* harmony import */ var src_configs_news__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3291);



const getNewsList = (0,effector__WEBPACK_IMPORTED_MODULE_2__/* .createEffect */ .GW)(async function() {
    let payload = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { data  } = await axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .ZP.post(src_configs_news__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getNewsList */ .Z.getNewsList(), payload);
    return data;
});
const news = (0,effector__WEBPACK_IMPORTED_MODULE_2__/* .createStore */ .MT)({
    data: [],
    count: 0,
    pages: 0,
    loading: true
}).on(getNewsList, (state)=>{
    return {
        ...state,
        loading: true
    };
}).on(getNewsList.doneData, (state, payload)=>{
    return {
        ...state,
        data: payload.data,
        count: payload.count,
        pages: payload.pages,
        loading: false
    };
});

/* harmony default export */ __webpack_exports__["Z"] = ({
    news
});


/***/ }),

/***/ 149:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ onLoadedVideo; }
/* harmony export */ });
/* harmony import */ var effector__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8116);

const onLoadedVideo = (0,effector__WEBPACK_IMPORTED_MODULE_0__/* .createEvent */ .yM)();
const video = (0,effector__WEBPACK_IMPORTED_MODULE_0__/* .createStore */ .MT)({
    preload: true
}).on(onLoadedVideo, (state)=>{
    return {
        ...state,
        preload: false
    };
});

/* harmony default export */ __webpack_exports__["Z"] = ({
    video
});


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [524,100,515,774,888,179], function() { return __webpack_exec__(8312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);